import { routerStore } from 'core/routing';

import { clientStore } from 'apps/client/app';
import { headerStore } from 'apps/components/header/app';
import { frameStore } from 'apps/components/Frame/appManager';

// import { manufacturerListingManager } from 'apps/manufacturing/appManager';
import { searchManager } from 'apps/search/appManager';
import { notificationCenter } from 'apps/notificationCenter/appManager';
import { ProcessMonitorAppManager } from 'apps/processMonitor/appManager';

import { stripeStore } from 'apps/payment/stripe';

class RootStore {
  stores = {};

  constructor() {
    // this.stores.manufacturerListingManager = manufacturerListingManager;
    this.stores.searchManager = searchManager;
    this.stores.notificationCenter = notificationCenter;
    this.stores.processMonitor = new ProcessMonitorAppManager(
      null,
      {},
      { autoDispose: false },
    );
    this.stores.routerStore = routerStore;
    this.stores.clientStore = clientStore;
    this.stores.headerStore = headerStore;
    this.stores.stripeStore = stripeStore;
    this.stores.frameStore = frameStore;
  }
}

export const rootStore = new RootStore();
